module.exports = __webpack_public_path__ + "img/unknown.1f20609.svg";